import { createContext, Dispatch, SetStateAction } from "react";

interface WizardDataFormContextProps {

    canShowConfirmIssue:            boolean;
    setCanShowConfirmIssue:         Dispatch<SetStateAction<boolean>>
    
    showSecondaryButton:            boolean;
    setShowSecondaryButton:         Dispatch<SetStateAction<boolean>>

}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);